import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	currentAccount: {
		id: 'project-create-importer-upload-flow.common.site-name.current-account',
		defaultMessage: 'Current account',
		description: 'Text for Current account',
	},
	retry: {
		id: 'project-create-importer-upload-flow.common.site-name.retry',
		defaultMessage: 'Retry',
		description: 'Text for Retry',
	},
});
